import './footer.css'
import { Link, useLocation } from 'react-router-dom'
import details from"../dataStore/details.json"

export default function Footer(){
    const location = useLocation()
    const path = location.pathname.substring(1)
    return(
        <div className='footer'>
            <article className='footerName'>
                <Link className='footerLogo'>
                    <h1>{details.name}</h1>
                    <p className='grey'>24/7 Taxi Service</p>
                    {/* <figure>
                        <img src='./images/footerLogo.png' alt='Zion Cab'/>
                    </figure> */}
                </Link>
                <p>118, Peramanur Ford opp, Railway gate Maraimalai Nagar, Chengalpattu, Tamil Nadu. - 603209.</p>
                <figure className='footerIcon'>
                    <a href='https://www.instagram.com/'>
                        <img src='./images/insta.svg' alt='insta'/>
                    </a>
                    <a href='https://www.facebook.com/'>
                        <img src='./images/fb.svg' alt='fb'/>
                    </a>
                </figure>
            </article>
            <article>
                <h2>Quick Links</h2>
                <div>
                    <Link to='/' className={path===''?'indicatorFooter footerItem':'footerItem'}>Home</Link>
                    <Link to='/tariff' className={path==='tariff'?'indicatorFooter footerItem':'footerItem'}>Tariff</Link>
                    <Link to='/contact' className={path==='contact'?'indicatorFooter footerItem':'footerItem'}>Contact Us</Link>
                </div>
            </article>
            <article className='footerContact'>
                <h2>Contact Us</h2>
                <div>
                    <p> {details.primary_phone} / {details.secondary_phone}</p>
                    <p>{details.mail}</p>
                </div>
            </article>
            <figure className='footerBG'>
                <img src='./images/map.svg' alt='Map'/>
            </figure>
            <p className='trulle'>Designed and Devloped @<a href='https://trulle.in/'>Trulle</a></p>
        </div>
    )
}